<script>
import FichaRegistroEmpregado from '@/components/shared/servidor/FichaRegistroEmpregado.vue'

export default {
  extends: FichaRegistroEmpregado,
}
</script>
